import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// initial state
const state: recipient.state.RecipientState = {
	orgchart: {
		selectedUsers: {
			...Object.create(null),
			length: 0,
		},
		company: {
			items: [],
			current: null,
		},
		dept: {
			items: [],
			current: null,
			path: [],
		},
		user: {
			items: [],
			current: null,
			selectedItems: [],
			totalCount: 0,
		},
	},
	currentCompany: null,
	companies:[],
	loading: true,
	search: { query: null, totalCount: 0 },
	searchResults: Object.create(null),
	searchKeyword: '',
	view: 'tree',
}

export default {
	state,
	actions,
	getters,
	mutations,
}
